import React from 'react';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Table from 'reactstrap/lib/Table';

import { getOrders, Orders } from '@ttstr/api';
import { LoadingSpinner } from '@ttstr/components';
import { useDateTime } from '@ttstr/components/Intl/DateComponent';

const OrderListing: React.FC = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(false);
  const [orders, setOrders] = React.useState<Orders>([]);
  const dateTime = useDateTime();

  React.useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        setOrders(await getOrders());
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return <LoadingSpinner label={t('LOADING.DATA')} />;

  if (!orders.length) return <div className="alert alert-warning mt-2">{t('ORDERS.NO_ORDERS')}</div>;
  return (
    <Table striped hover className="tt-listing">
      <thead>
        <tr>
          <th scope="col">{t('ORDERS.ORDER_NUMBER')}</th>
          <th scope="col" className="text-center">
            {t('ORDERS.PAYMENT_STATUS')}
          </th>
          <th scope="col" className="text-center">
            {t('ORDERS.SHIPPING_STATUS')}
          </th>
          <th scope="col" className="text-right">
            <span className="sr-only">{t('ORDERS.ACTION')}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        {orders.map((order) => (
          <tr key={order.id}>
            <th scope="row" title={order.created_at && dateTime.format(order.created_at)}>
              {order.order_no}
            </th>
            <td className="text-center" title={order.paid_at && dateTime.format(order.paid_at)}>
              {order.payment_status}
            </td>
            <td className="text-center" title={order.shipped_at && dateTime.format(order.shipped_at)}>
              {order.shipping_status}
            </td>
            <td className="text-right">
              <Link to={`/customer/orders/${encodeURIComponent(order.id)}`} className="btn btn-xs btn-primary">
                {t('ORDERS.GOTO_DETAILS')}
              </Link>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default React.memo(OrderListing);
